function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  x: "-8.7%",
  y: "-13.2%",
  width: "117.3%",
  height: "126.5%",
  filterUnits: "objectBoundingBox",
  id: "banner-light_svg__a"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 6,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "shadowBlurOuter1",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0",
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  "in": "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 9,
  "in": "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feComposite", {
  "in": "shadowBlurOuter2",
  in2: "SourceAlpha",
  operator: "out",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0",
  "in": "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter2"
}))), /*#__PURE__*/React.createElement("filter", {
  x: "-10.3%",
  y: "-46.7%",
  width: "120.5%",
  height: "206.7%",
  filterUnits: "objectBoundingBox",
  id: "banner-light_svg__d"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 4,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  x1: "50%",
  y1: ".488%",
  x2: "50%",
  y2: "100%",
  id: "banner-light_svg__c"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAEFFE",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DAEFFE",
  stopOpacity: 0,
  offset: "100%"
})), /*#__PURE__*/React.createElement("rect", {
  id: "banner-light_svg__b",
  x: 0,
  y: 0,
  width: 312,
  height: 204,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h312v56a4 4 0 01-4 4H4a4 4 0 01-4-4V0z",
  id: "banner-light_svg__e"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#banner-light_svg__a)",
  xlinkHref: "#banner-light_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0,
  fill: "#FFF",
  xlinkHref: "#banner-light_svg__b"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#DAEFFE",
  width: 312,
  height: 204,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 0h304a4 4 0 014 4v8H0V4a4 4 0 014-4z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#DFE5EB",
  d: "M.5 11.5h311v1H.5z"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 4,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 11,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#B6C1CD",
  x: 18,
  y: 4,
  width: 4,
  height: 4,
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C1E4FE",
  d: "M16 105h58v58H16zM90 131h58v32H90zM90 35h58v80H90zM164 105h58v58h-58zM238 124h58v39h-58zM238 35h58v73h-58zM164 35h58v54h-58zM16 35h58v54H16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#banner-light_svg__c)",
  d: "M10 35h292v128H10z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 144)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#banner-light_svg__d)",
  xlinkHref: "#banner-light_svg__e"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#banner-light_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M260 174h40v18h-40z"
}), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  fill: "#7A92A5",
  d: "M220 181h28v4h-28z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  d: "M214.5 174.5h39v17h-39z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M266 181h28v4h-28z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#162D3D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M302.44 153.5l-2.44-2.44a.75.75 0 111.06-1.06l2.44 2.44 2.44-2.44a.75.75 0 011.06 1.06l-2.44 2.44 2.44 2.44a.75.75 0 01-1.06 1.06l-2.44-2.44-2.44 2.44a.75.75 0 01-1.06-1.06l2.44-2.44z"
})), /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  fill: "#7A92A5",
  d: "M12 156h150v6H12zM12 168h100v6H12zM12 180h40v6H12z"
})));

function SvgBannerLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 204,
    viewBox: "0 0 312 204"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='312px' height='204px' viewBox='0 0 312 204' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3C!-- Generator: Sketch 64 (93537) - https://sketch.com --%3E %3Ctitle%3EBanner Light%3C/title%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cdefs%3E %3Crect id='path-1' x='0' y='0' width='312' height='204' rx='4'%3E%3C/rect%3E %3Cfilter x='-8.7%25' y='-13.2%25' width='117.3%25' height='126.5%25' filterUnits='objectBoundingBox' id='filter-2'%3E %3CfeOffset dx='0' dy='6' in='SourceAlpha' result='shadowOffsetOuter1'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='3' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3E%3C/feGaussianBlur%3E %3CfeComposite in='shadowBlurOuter1' in2='SourceAlpha' operator='out' result='shadowBlurOuter1'%3E%3C/feComposite%3E %3CfeColorMatrix values='0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.06 0' type='matrix' in='shadowBlurOuter1' result='shadowMatrixOuter1'%3E%3C/feColorMatrix%3E %3CfeOffset dx='0' dy='0' in='SourceAlpha' result='shadowOffsetOuter2'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='9' in='shadowOffsetOuter2' result='shadowBlurOuter2'%3E%3C/feGaussianBlur%3E %3CfeComposite in='shadowBlurOuter2' in2='SourceAlpha' operator='out' result='shadowBlurOuter2'%3E%3C/feComposite%3E %3CfeColorMatrix values='0 0 0 0 0.0862745098 0 0 0 0 0.176470588 0 0 0 0 0.239215686 0 0 0 0.12 0' type='matrix' in='shadowBlurOuter2' result='shadowMatrixOuter2'%3E%3C/feColorMatrix%3E %3CfeMerge%3E %3CfeMergeNode in='shadowMatrixOuter1'%3E%3C/feMergeNode%3E %3CfeMergeNode in='shadowMatrixOuter2'%3E%3C/feMergeNode%3E %3C/feMerge%3E %3C/filter%3E %3ClinearGradient x1='50%25' y1='0.48828125%25' x2='50%25' y2='100%25' id='linearGradient-3'%3E %3Cstop stop-color='%23DAEFFE' offset='0%25'%3E%3C/stop%3E %3Cstop stop-color='%23DAEFFE' stop-opacity='0' offset='100%25'%3E%3C/stop%3E %3C/linearGradient%3E %3Cpath d='M0,0 L312,0 L312,56 C312,58.209139 310.209139,60 308,60 L4,60 C1.790861,60 2.705415e-16,58.209139 0,56 L0,0 L0,0 Z' id='path-4'%3E%3C/path%3E %3Cfilter x='-10.3%25' y='-46.7%25' width='120.5%25' height='206.7%25' filterUnits='objectBoundingBox' id='filter-5'%3E %3CfeOffset dx='0' dy='4' in='SourceAlpha' result='shadowOffsetOuter1'%3E%3C/feOffset%3E %3CfeGaussianBlur stdDeviation='10' in='shadowOffsetOuter1' result='shadowBlurOuter1'%3E%3C/feGaussianBlur%3E %3CfeColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0' type='matrix' in='shadowBlurOuter1'%3E%3C/feColorMatrix%3E %3C/filter%3E %3C/defs%3E %3Cg id='Banner-Light' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg id='Preview-Banner-/-Light'%3E %3Cg id='Group-11'%3E %3Cg id='p-/-12-/-12.7-/-Shadow'%3E %3Cg id='Rectangle'%3E %3Cuse fill='black' fill-opacity='1' filter='url(%23filter-2)' xlink:href='%23path-1'%3E%3C/use%3E %3Cuse fill-opacity='0' fill='%23FFFFFF' fill-rule='evenodd' xlink:href='%23path-1'%3E%3C/use%3E %3C/g%3E %3C/g%3E %3Crect id='Rectangle' fill='%23DAEFFE' x='0' y='0' width='312' height='204' rx='4'%3E%3C/rect%3E %3Cg id='B-Bar'%3E %3Cpath d='M4,0 L308,0 C310.209139,-4.05812251e-16 312,1.790861 312,4 L312,12 L312,12 L0,12 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z' id='Rectangle' fill='%23FFFFFF'%3E%3C/path%3E %3Crect id='Rectangle' stroke='%23DFE5EB' x='0.5' y='11.5' width='311' height='1'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='4' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='11' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3Crect id='Rectangle' fill='%23B6C1CD' x='18' y='4' width='4' height='4' rx='2'%3E%3C/rect%3E %3C/g%3E %3Crect id='Rectangle' fill='%23C1E4FE' x='16' y='105' width='58' height='58'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-6' fill='%23C1E4FE' x='90' y='131' width='58' height='32'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-14' fill='%23C1E4FE' x='90' y='35' width='58' height='80'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-9' fill='%23C1E4FE' x='164' y='105' width='58' height='58'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-11' fill='%23C1E4FE' x='238' y='124' width='58' height='39'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-15' fill='%23C1E4FE' x='238' y='35' width='58' height='73'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-19' fill='%23C1E4FE' x='164' y='35' width='58' height='54'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-20' fill='%23C1E4FE' x='16' y='35' width='58' height='54'%3E%3C/rect%3E %3Crect id='Rectangle' fill='url(%23linearGradient-3)' x='10' y='35' width='292' height='128'%3E%3C/rect%3E %3C/g%3E %3Cg id='Group-2' transform='translate(0.000000, 144.000000)'%3E %3Cg id='Group'%3E %3Cg id='Group-13'%3E %3Cg id='Rectangle-Copy-16'%3E %3Cuse fill='black' fill-opacity='1' filter='url(%23filter-5)' xlink:href='%23path-4'%3E%3C/use%3E %3Cuse fill='%23FFFFFF' fill-rule='evenodd' xlink:href='%23path-4'%3E%3C/use%3E %3C/g%3E %3Crect id='Rectangle-Copy-17' fill='%23000000' x='260' y='30' width='40' height='18'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-4' fill-opacity='0.2' fill='%237A92A5' x='220' y='37' width='28' height='4'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-18' stroke='%23000000' x='214.5' y='30.5' width='39' height='17'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-4' fill='%23333333' x='266' y='37' width='28' height='4'%3E%3C/rect%3E %3C/g%3E %3Cg id='01-Foundation-/-Icon-Small-18-/-01-Actions-/-08-Dismiss' transform='translate(294.000000, 0.000000)' fill='%23162D3D'%3E %3Cpath d='M8.43933983,9.5 L6,7.06066017 C5.70710678,6.76776695 5.70710678,6.29289322 6,6 C6.29289322,5.70710678 6.76776695,5.70710678 7.06066017,6 L9.5,8.43933983 L11.9393398,6 C12.232233,5.70710678 12.7071068,5.70710678 13,6 C13.2928932,6.29289322 13.2928932,6.76776695 13,7.06066017 L10.5606602,9.5 L13,11.9393398 C13.2928932,12.232233 13.2928932,12.7071068 13,13 C12.7071068,13.2928932 12.232233,13.2928932 11.9393398,13 L9.5,10.5606602 L7.06066017,13 C6.76776695,13.2928932 6.29289322,13.2928932 6,13 C5.70710678,12.7071068 5.70710678,12.232233 6,11.9393398 L8.43933983,9.5 Z' id='Color'%3E%3C/path%3E %3C/g%3E %3C/g%3E %3Crect id='Rectangle' fill-opacity='0.2' fill='%237A92A5' x='12' y='12' width='150' height='6'%3E%3C/rect%3E %3Crect id='Rectangle-Copy' fill-opacity='0.2' fill='%237A92A5' x='12' y='24' width='100' height='6'%3E%3C/rect%3E %3Crect id='Rectangle-Copy-4' fill-opacity='0.2' fill='%237A92A5' x='12' y='36' width='40' height='6'%3E%3C/rect%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgBannerLight as ReactComponent };